/* eslint-disable react/jsx-no-target-blank */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { DrawerComponent } from '../../../assets/ts/components';
import { KTSVG, toAbsoluteUrl } from '../../../helpers';
import { useLayout } from '../../core';
import { AsideMenu } from './AsideMenu';

const AsideDefault: FC = () => {
  const { config, classes } = useLayout();
  const { aside } = config;
  const asideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Eski overlay'leri temizle
    const cleanupOverlays = () => {
      const overlays = document.querySelectorAll('.drawer-overlay');
      overlays.forEach((overlay) => overlay.remove());
    };

    // Drawer component'i initialize et
    setTimeout(() => {
      cleanupOverlays();
      DrawerComponent.reinitialization();
    }, 100);

    // Aside toggle butonuna click event'i ekle
    const toggleButton = document.getElementById('kt_aside_toggle');
    const handleToggleClick = (e: Event) => {
      e.preventDefault();
      const drawerElement = document.getElementById('kt_aside');
      if (drawerElement) {
        const drawerInstance = DrawerComponent.getInstance(drawerElement);
        if (drawerInstance) {
          // Mobil/tablet modda ise tamamen kapat
          if (window.innerWidth < 992) {
            drawerInstance.hide();
            // Overlay'leri temizle
            setTimeout(cleanupOverlays, 50);
          } else {
            // Desktop'ta da toggle işlemini yap
            drawerInstance.toggle();
            // Overlay'leri temizle
            setTimeout(cleanupOverlays, 50);
          }
        }
      }
    };

    if (toggleButton) {
      toggleButton.addEventListener('click', handleToggleClick);
    }

    // Ekran boyutu değişikliklerini dinle
    const handleResize = () => {
      if (window.innerWidth < 992) {
        // lg breakpoint (Bootstrap)
        // Mobil/tablet modda sidebar'ı kapat
        const drawerElement = document.getElementById('kt_aside');
        if (drawerElement) {
          const drawerInstance = DrawerComponent.getInstance(drawerElement);
          if (drawerInstance && drawerInstance.isShown()) {
            drawerInstance.hide();
            // Overlay'leri temizle
            setTimeout(cleanupOverlays, 50);
          }
        }
      }
    };

    // İlk yüklemede kontrol et
    handleResize();

    // Resize event listener ekle
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (toggleButton) {
        toggleButton.removeEventListener('click', handleToggleClick);
      }
      cleanupOverlays();
    };
  }, []);

  return (
    <div
      ref={asideRef}
      id="kt_aside"
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle"
    >
      {/* begin::Brand */}
      <div className="aside-logo flex-column-auto" id="kt_aside_logo">
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <Link to="/dashboard">
            <div className="text-white fw-bolder fs-3 logo">
              <img alt="Logo" className="h-35px logo" src={toAbsoluteUrl('/media/logos/logo-light.svg')} />
            </div>
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to="/dashboard">
            <img alt="Logo" className="h-35px logo" src={toAbsoluteUrl('/media/logos/logo.svg')} />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id="kt_aside_toggle"
            className="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
            data-kt-toggle="true"
            data-kt-toggle-state="active"
            data-kt-toggle-target="body"
            data-kt-toggle-name="aside-minimize"
          >
            <KTSVG path={'/media/icons/duotone/Navigation/Angle-double-left.svg'} className={'svg-icon-1 rotate-180'} />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className="aside-menu flex-column-fluid">
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
        <a
          target="_blank"
          className="btn btn-custom btn-danger w-100"
          href="/logout"
          data-bs-toggle="tooltip"
          data-bs-trigger="hover"
          data-bs-dismiss-="click"
          title="Çıkış Yap"
          data-bs-original-title="Çıkış Yap"
        >
          Çıkış Yap
        </a>
      </div>
      {/* end::Footer */}
    </div>
  );
};

export { AsideDefault };
